/**
 * Syndicate role labels, as the `company_role` dictionary names them.
 */
export const LEAD_ROLE = {
  structuring: 'Structuring Lead',
  left: 'Left Lead',
  active: 'Active Lead',
  joint: 'Joint Lead',
  passive: 'Passive Lead',
  billingDelivering: 'Billing & Delivering',
  coManager: 'Co-Manager',
  coordinatingManager: 'Coordinating Manager',
  diCoordinator: 'D&I Coordinator',
} as const;
